
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("aIqdH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c09c99e6f93d598c$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $c09c99e6f93d598c$export$2e2bcd8739ae039 = {
    'navigation.global-shortcuts.all-sites': "\uBAA8\uB4E0 \uC0AC\uC774\uD2B8",
    'navigation.global-shortcuts.menu-expand-item.close-button-aria-label': "\uB2EB\uAE30",
    'navigation.global-shortcuts.menu-link-item.disabled-item-aria-label': "(\uD604\uC7AC \uC0AC\uC6A9\uD560 \uC218 \uC5C6\uC74C)",
    'navigation.global-shortcuts.sites': "{productName} \uC0AC\uC774\uD2B8"
};

});


//# sourceMappingURL=ko.d5a5f023.js.map
